import type { StudioIncludes } from '@bond/bruce-api/api/studio/response'

export function uniqueCategoriesFromStudios(
  studios: StudioIncludes<{ params: { include_categories: true } }>[],
) {
  return Array.from(
    new Set([
      ...studios.flatMap((studio) =>
        studio.categories.map((category) => category.title),
      ),
    ]),
  ).filter((category) => category !== null)
}
